import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    closeButtonText: 'Close',
    condensedPackageLabel: '+ {0} months of {1}',
    first: 'First',
    hideDetails: 'Hide plan details',
    monthlyPayment: 'Then {0} / month excl. tax',
    packageDetails: 'excl. tax.',
    packageLabel: '{0} +\n{1} months of {2}',
    packages: {
      capitalDeposit: 'Capital Deposit',
      shineStart: 'Shine Start',
    },
    priceDetails: 'Per month. excl. tax.',
    refferalOffer: 'Get **2 free months** on any plan thanks to {0}!',
    refferer: 'by {0}',
    secondSectionTitle: 'In detail',
    seeDetails: 'Show plan details',
    title: 'Select your offer',
    topBarPriceText: '**{0} /** month',
    trialPeriod: '{0} month{1} free',
    variantSolo: 'Freelancers',
    variantTeam: 'TPE / Startups',
    yourCurrentOffer: 'Your current offer',
  },
  fr: {
    closeButtonText: 'Fermer',
    condensedPackageLabel: '+ {0} mois de {1}',
    first: 'Premier',
    hideDetails: 'Cacher le détail des plans',
    monthlyPayment: 'Puis {0} / mois HT',
    packageDetails: 'HT',
    packageLabel: '{0} +\n{1} mois de {2}',
    packages: {
      capitalDeposit: 'Capital deposit',
      shineStart: 'Shine Start',
    },
    priceDetails: 'Par mois HT',
    refferalOffer:
      'Bénéficiez quelque soit l’offre choisie, **de 2 mois offerts**, dites merci à {0} !',
    refferer: 'par {0}',
    secondSectionTitle: 'En détails',
    seeDetails: 'Voir le détail des plans',
    title: 'Choisissez votre offre',
    topBarPriceText: '**{0} /** mois. HT',
    trialPeriod: '{0} mois gratuit{1}',
    variantSolo: 'Indépendant·es',
    variantTeam: 'TPE / Startups',
    yourCurrentOffer: 'Votre offre actuelle',
  },
} as const);
